import { debounce } from "@js/utilities/_throttleDebounce"

export const customSelect = (type, selectedValue = null) => ({
	selectedValue: selectedValue,
	isOpen: false,
	selectedEl: 'Select option',
	type: type || null,

	init() {
		this.selectedEl = this.$root.querySelector('.customSelect__selected')

		if (this.selectedValue !== null) {
			this.selectOption(this.selectedValue)
		}

		setTimeout(() => {
			if (this.type === 'colour' || this.type === 'style' || this.type === 'size' || this.type === 'powerPref') {
				this.updateMatchingFilterOption()
			}
		}, 1000)

		window.addEventListener("variantUpdated", debounce((e) => {
			if (this.type === 'colour' || this.type === 'style' || this.type === 'size' || this.type === 'powerPref') {
				this.updateMatchingFilterOption(true)
			}
		}, 500))
	},

	toggleOptions() {
		this.isOpen = !this.isOpen
	},

	selectOption(optionValue = null, isEnterKey = false) {
		let formattedMatchingOption = null

		if (optionValue === null) {
			this.selectedValue = ''

			formattedMatchingOption = this.$root.querySelectorAll('.customSelect__option')[0]
		} else {
			this.selectedValue = optionValue.toString()

			formattedMatchingOption = this.$root.querySelector('.customSelect__option[data-key="' + this.selectedValue + '"]')
		}

		this.isOpen = false

		if (isEnterKey) {
			setTimeout(() => {
				this.selectedEl.focus()
			}, 1000)
		}

		if (formattedMatchingOption !== null) {
			this.selectedEl.innerHTML = formattedMatchingOption.innerHTML.replace(/\s*:style="[^"]*"/g, '').replace(/\s*x-show="[^"]*"/g, '').replace(/\s*x-text="[^"]*"/g, '')
		} else {
			formattedMatchingOption = this.$root.querySelectorAll('.customSelect__option')[0]
			this.selectedEl.innerHTML = formattedMatchingOption.innerHTML.replace(/\s*:style="[^"]*"/g, '').replace(/\s*x-show="[^"]*"/g, '').replace(/\s*x-text="[^"]*"/g, '')
		}

		if (this.type === 'colour' || this.type === 'style' || this.type === 'size' || this.type === 'powerPref') {
			const matchingFilterButton = this.$root.parentNode.querySelector('.filterButton[data-key="' + this.selectedValue + '"]')

			if (!matchingFilterButton.classList.contains('filterButton--active')) {
				const matchingFilterClickEvent = new Event('click')
				matchingFilterButton.dispatchEvent(matchingFilterClickEvent)
			}
		}

		if (this.type === 'colourSprig' || this.type === 'categorySprig') {
			this.updateMatchingSprigSelect()
		}
	},

	updateMatchingFilterOption() {
		if (this.$root.parentNode.querySelector('.filterButton--active') === null) {
			this.selectedValue = null
			this.selectedEl.innerHTML = 'Select option'

			return
		}

		const firstActiveFilterButton = this.$root.parentNode.querySelector('.filterButton--active')
		const firstActiveFilterButtonKey = firstActiveFilterButton.getAttribute('data-key')
		this.selectedValue = firstActiveFilterButtonKey

		const matchingOption = this.$root.querySelector('.customSelect__option[data-key="' + this.selectedValue + '"]')

		if (matchingOption !== null) {
			this.selectOption(this.selectedValue)
		}

		const allFilterButtons = this.$root.parentNode.querySelectorAll('.filterButton')

		for (const filterButton of allFilterButtons) {
			const filterButtonKey = filterButton.getAttribute('data-key')

			const matchingOption = this.$root.querySelector('.customSelect__option[data-key="' + filterButtonKey + '"]')

			if (matchingOption === null) continue

			if (filterButton.disabled) {
				matchingOption.disabled = true
			} else {
				matchingOption.disabled = false
			}
		}
	},

	updateMatchingSprigSelect() {
		const sprigSelect = document.querySelector(this.$root.getAttribute('data-select-to-sync'))
		if (sprigSelect === null) return

		const matchingSprigOption = sprigSelect.querySelector('option[value="' + this.selectedValue + '"]')

		if (matchingSprigOption.disabled) {
			sprigSelect.value = ''

			const sprigChangeEvent = new Event('change')
			sprigSelect.dispatchEvent(sprigChangeEvent)

			return
		}

		sprigSelect.value = this.selectedValue

		const sprigChangeEvent = new Event('change')
		sprigSelect.dispatchEvent(sprigChangeEvent)
	}
})
